import React, { Component } from "react";
// import Header from './../Header';
// import Footer from "./../Footer";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import './../../../../public/scss/EmployeeManagment.scss';

import { adminFetchEmployeeInformation, getAllAssessmentsForAdmin,validateEmpId,getScoreCardData,showScoreCardLoader } from './../../../../actions/webRedActions';
import { autoFocusNextField,getYear } from './../../../../actions/utility';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import userData from './../userData';

import {
    Button,
    Container,
    Row,
    Col,
    Media,
    Form, FormGroup, Label, Input, FormText,
    Spinner
  } from "reactstrap";

// import readXlsxFile from 'read-excel-file';

// import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class EmployeeSearchForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
            // userInfo : {
            //     employee_id : '01-1234'
            // }, // dummy user data
            employeeId : ["", "", "-", "", "", "", ""],
            employeeIdString : "",
            employeeIdError : "",
            isLoading: false,
            // enableNextBtn : false

        };
    }
  
    componentDidMount() {
        // alert(this.props.selYear)
        autoFocusNextField("boxFieldForm"); // auto focus utility method called
        if(this.props.selYear) {
            this.props.adminFetchEmployeeInformation(this.state.employeeIdString,this.props.selYear);
        }

    }
    
    componentWillReceiveProps(nextProps, thisProps) {
        
        //console.log('nextProps:',nextProps)

        if(this.props.fetchEmpDataSuccessAdmin != nextProps.fetchEmpDataSuccessAdmin) {
            // console.log(nextProps.fetchEmpDataSuccessAdmin);
            if(nextProps.fetchEmpDataSuccessAdmin.result && !nextProps.fetchEmpDataSuccessAdmin.result.profile && nextProps.fetchEmpDataSuccessAdmin.result.profile == null) { // invalid employee id
                this.setState({
                    employeeIdError : "Employee id is not valid or data not found",
                    isLoading : false
                })
            } else {
                this.setState({
                    employeeIdError : '',
                    isLoading : false
                })
            }
        }
        if(this.props.validateEmailIDRes != nextProps.validateEmailIDRes) {
            console.log('Faheem in iff:',nextProps.validateEmailIDRes.result);
            if(nextProps.validateEmailIDRes.result && nextProps.validateEmailIDRes.result.status == 'success' && nextProps.validateEmailIDRes.result.result == '1') {
                this.setState({
                    employeeIdError : "Employee ID is already assigned. Please enter new ID above ",
                    isLoading : false
                })
            } else {
                this.setState({
                    employeeIdError : '',
                    isLoading : false
                })
            }
        }
        if(this.props.selectedYear != nextProps.selectedYear) {
            // alert(this.state.employeeIdString+"hhh"+nextProps.selectedYear)
            const {employeeIdString} = this.state;
            this.props.adminFetchEmployeeInformation(employeeIdString,nextProps.selectedYear);
            // get all the assessments list for this employee
            // this.props.getAllAssessmentsForAdmin(employeeIdString);
            //get the current employee score
            var year = getYear();
            this.props.getScoreCardData(employeeIdString,year)
            this.props.showScoreCardLoader()
        }


    }

    handleChange = (event, index) => {
        event.preventDefault();
        const { name, value } = event.target;

        var employeeIdTemp = this.state.employeeId;
        employeeIdTemp[index] = value;

        this.setState({
            [name] : employeeIdTemp
        }, () => {
            // console.log(this.state.employeeId);

            var emp_id = this.convertEmpIdToString(this.state.employeeId);
            this.setState({
                employeeIdString : emp_id
            }, () => {
                // it means all inputs are done here we need to call action to verify
                
                if(emp_id.length == 7) {
                }
                // console.log(this.state.employeeIdString)
            })

        })

        if(this.state.employeeIdError != "") {
            this.setState({
                employeeIdError : ""
            })
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        
    }

    convertEmpIdToString = (empId) => {
        var stringEmpId = "";
        empId.map(val => {
            if(val && val != "" && val != undefined){
                stringEmpId += val;
            }
        })

        return stringEmpId;
    }

    render() {

    const {employeeId, employeeIdError, employeeIdString, isLoading} = this.state;

    return (
      <Container className="EmployeeSearchForm"  style={{padding: '8vh 5vw', textAlign: 'center'}}>

        
        <Row>
            <Col md={{size: 12, offset: 0}}>
                <Form>
                   <Row style={{
                        marginBottom: '30px',
                        padding: '1.5rem 1rem',
                        backgroundColor: '#fef67f',
                        border: '1px #ffd29b solid',
                        borderRadius: '3px'
                    }}>
                     <Col md={4} style={{textAlign: 'right'}}>
                        <p>{typeof this.props.textTitle !=='undefined' ? this.props.textTitle :'Search by employee id:'}</p>
                     </Col>  
                     <Col md={5} style={{textAlign: 'left'}}>
                        <FormGroup className="boxFieldForm" style={{marginBottom: 0}}>
                        
                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId1"
                                value={employeeId[0]}
                                onChange={evt => this.handleChange(evt, 0)} />

                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId2" 
                                value={employeeId[1]}
                                onChange={evt => this.handleChange(evt, 1)} />

                            <Input style={{
                                background: '#fef67f',
                                border: 'none',
                                fontSize: '36px',
                                height: '10px'
                            }} type="text" bsSize="lg" value="-" maxLength="1" name="dash" id="dash" disabled />

                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId3"
                                value={employeeId[3]}
                                onChange={evt => this.handleChange(evt, 3)} />

                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId4"
                                value={employeeId[4]}
                                onChange={evt => this.handleChange(evt, 4)} />

                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId5"
                                value={employeeId[5]}
                                onChange={evt => this.handleChange(evt, 5)} />

                            <Input type="text" bsSize="lg" maxLength="1" name="employeeId" id="employeeId6"
                                value={employeeId[6]}
                                onChange={evt => this.handleChange(evt, 6)} />

                        </FormGroup>
                    </Col>
                    <Col md={3} style={{textAlign: 'left'}}>
                    {
                        employeeIdString.length == 7 ?
                            typeof this.props.btnTitle === 'undefined' || this.props.btnTitle == '' ?
                            <Button className='clickYearData mt-3' style={{margin: '0 0 0 0'}} color={"warning"} size="lg"
                                onClick={(e) => {
                                    this.setState({
                                        isLoading : true
                                    }, () => {
                                        console.log('in the function');
                                        // get the profile information of this employee
                                        this.props.adminFetchEmployeeInformation(employeeIdString,this.props.selYear);
                                        // get all the assessments list for this employee
                                        // this.props.getAllAssessmentsForAdmin(employeeIdString);
                                        //get the current employee score
                                        var year = getYear();
                                        this.props.getScoreCardData(employeeIdString,year)
                                        this.props.showScoreCardLoader()
                                        setTimeout(function() {
                                            var elements = document.querySelectorAll('.selectedyear');
                                            if (elements.length > 0) {
                                                var lastElement = elements[elements.length - 1];
                                                if (lastElement.children.length > 0) {
                                                    lastElement.children[0].style.borderTop = '2px solid black';
                                                }
                                            }
                                        }, 1000);
                                    })
                                }}
                                disabled={isLoading}
                            >
                                Search
                                {
                                    isLoading ? <Spinner style={{margin: '4px 0px 4px 10px'}} color="light" size="sm" /> : null
                                }
                            </Button>
                            :<Button style={{margin: '0 0 0 0'}} color={"warning"} size="lg"
                            onClick={(e) => {
                                this.setState({
                                    isLoading : true
                                }, () => {
                                    this.props.validateEmpId(employeeIdString);
                                })
                            }}
                            disabled={isLoading}
                        >
                            {this.props.btnTitle}
                            {
                                isLoading ? <Spinner style={{margin: '4px 0px 4px 10px'}} color="light" size="sm" /> : null
                            }
                        </Button>
                        : null
                    }
                    </Col>

                    {
                        employeeIdError && employeeIdError != "" ?
                        <Col>
                            <p style={{color: 'red'}}>
                                <FontAwesomeIcon icon={faTimesCircle} size="1x" style={{marginRight: '10px'}} />
                                {employeeIdError}
                            </p>
                            </Col>
                        : null
                    }
                    </Row>
                </Form>
            </Col>
        </Row>
        <Row>
            <Col style={{textAlign: 'center'}}>
              
            </Col>
        </Row>
      </Container>
    );
  }
}

EmployeeSearchForm.propTypes = {
    adminFetchEmployeeInformation: PropTypes.func.isRequired,
    getAllAssessmentsForAdmin: PropTypes.func.isRequired,
    validateEmpId: PropTypes.func.isRequired,
    getScoreCardData: PropTypes.func.isRequired,
    showScoreCardLoader: PropTypes.func.isRequired
}

const mapStatesToProps = state => ({
    fetchEmpDataSuccessAdmin : state.webRed.fetchEmpDataSuccessAdmin,
    validateEmailIDRes : state.webRed.validateEmailIDRes,
    selectedYear : state.webRed.selectedYear
})

export default connect( mapStatesToProps, { adminFetchEmployeeInformation, getAllAssessmentsForAdmin,validateEmpId,getScoreCardData,showScoreCardLoader })( EmployeeSearchForm );